module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1e9652bec24bcaacf5285be19746a750.svg";